/* eslint-disable */
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { showNotification } from "@mantine/notifications";
import { customAxios } from "lib/axios";

export type ChangeLeaveTypePayload = {
  leaveId: string;
  newLeaveType: "sick" | "casual" | "annual" | string;
};

export type ChangeLeaveTypeResponse = {
  success: boolean;
  message?: string;
  data?: any;
};

const changeLeaveType = async (payload: ChangeLeaveTypePayload) => {
  const res = await customAxios.put<ChangeLeaveTypeResponse>(
    "/leaves/admin-change-leave-type",
    payload
  );
  return res.data;
};

export const useChangeLeaveType = () => {
  const queryClient = useQueryClient();

  return useMutation<
    ChangeLeaveTypeResponse,
    AxiosError,
    ChangeLeaveTypePayload
  >((payload: ChangeLeaveTypePayload) => changeLeaveType(payload), {
    onSuccess: (data, variables) => {
      showNotification({
        title: "Leave Type Updated",
        message: data?.message || `Leave type changed successfully`,
        color: "green",
      });

      queryClient.invalidateQueries({
        predicate: (query) => query.queryKey?.[0] === "leaveRequestsAdmin",
      });
    },
    onError: (error: AxiosError) => {
      showNotification({
        title: "Leave Type Update Failed",
        message: "Failed to change leave type. Please try again.",
        color: "red",
      });
    },
    retry: 1,
  });
};
